<template>
    <div class="px-3">
      <!-- <div v-if="loading" class="text-center">
        <i class="fas fa-spinner fa-spin mr-2"></i><small>Loading ...</small>
          </div> -->

        <table v-if="projects.length > 0" class="table">
          <tbody>
            <tr class="body" v-for="(project, index) in projects" :key="index.id" @click="openlink(project.id)">
              
              <td>
        <div class="project_list_title"><a :href="'/projects/view/'+project.id+'/0'">{{project.title}}</a></div>
        <div class="project_list_description">{{strip_tags(project.description)}}</div>
        
        <!-- Desktop -->
        <div class="row d-none d-md-block">
                <div class="col">
            <div class="badge badge-danger">{{project.category.name}}</div>
            <div class="badge badge-dark ml-1">{{project.status}}</div>
            <div class="badge badge-dark ml-1" v-if="project.budget && !project.price">Budget {{formattedPrice(project.budget)}}</div>
            <div class="badge badge-dark ml-1" v-if="project.price">Accepted Price {{formattedPrice(project.price)}}</div>
            <div class="badge badge-dark ml-1" v-else-if="project.quote">Quote {{formattedPrice(project.quote)}}</div>
                </div>
            </div>
        
        <!-- Mobile -->
        <div class="d-block d-md-none">
        <div><span class="badge badge-danger mb-2">{{project.category.name}}</span></div>
        <div><span class="badge badge-dark mb-2">{{project.status}}</span></div>
        <div v-if="project.budget && !project.price"><span class="badge badge-dark mb-1">Budget {{formattedPrice(project.budget)}}</span></div>
        <div v-if="project.price"><span class="badge badge-dark mb-1">Accepted Price {{formattedPrice(project.price)}}</span></div>
        <div v-if="project.quote"><span class="badge badge-dark mb-1">Quote {{formattedPrice(project.quote)}}</span></div>
        </div>

        <div class="project_list_date"><small><timeago
                  :datetime="project.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(project.created_at)"></timeago></small>
          </div>
      </td>

            </tr>
          </tbody>
        </table>

<p v-else class="pt-3 text-center">No projects</p>

  </div>
</template> 

<script>
export default {
  props: ['status'],

  data() {
    return {
      projects: [],
      loading: false,
    };
  },

  created() {
    this.getProjects();

      Echo.private("seller_projects")
      .listen("NewProject", (event) => {
        this.getProjects();
      });

  },

  methods: {
    openlink(id) {
      if (id) {
        window.open(`/projects/view/${id}/0`, '_self');
      }
    },

    getProjects() {

      this.loading = true;

      axios.post('/projects/seller', {status: this.status}).
      then((response) => {
        this.projects = response.data;
        this.loading = false;
      });
    },

  },
};
</script>

<style scoped>

</style>